import PageBanner from "../../../../src/components/PageBanner";
import EventsBody from "../../../../src/components/events/eventsBody";
import DefaultNoHead from "../../../../src/gatsby-theme-carbon/templates/DefaultNoHead";
import * as React from 'react';
export default {
  PageBanner,
  EventsBody,
  DefaultNoHead,
  React
};